export const FETCH_USER_SUCCESS = 'fetch_user_success';
export const FETCH_USER_FAIL = 'fetch_user_fail';
export const FETCH_USER_REQUEST = 'fetch_user_request';



// WEBPACK FOOTER //
// ./src/constants/types.js